// Utils
import { getPreviousSiblingViaGraph } from '../../../../../../../common/elements/utils/elementGraphUtils';
import { sortByScoreProperty } from '../../../../../../../common/elements/utils/elementSortUtils';
import { getTaskListAncestorId } from '../../../../../../../common/taskLists/taskListUtils';
import { getDepth, getParent } from '../../../../../../../common/elements/utils/elementTraversalUtils';
import { isTaskList } from '../../../../../../../common/elements/utils/elementTypeUtils';

// Selectors
import { getCurrentlyEditingId } from '../../../../../../element/selection/currentlyEditingSelector';
import { getElements } from '../../../../../../element/selectors/elementsSelector';
import { elementGraphSelector } from '../../../../../../element/selectors/elementGraphSelector';

// Constants
import { MAX_TASK_DEPTH } from '../../../../../../element/taskList/taskListActions';
import { ImmutableMap } from '../../../../../../../common/utils/immutableHelper';

export const isIndentTaskToolDisabledSelector = (state: ImmutableMap) => {
    const elements = getElements(state);
    const elementGraph = elementGraphSelector(state);

    const currentlyEditingId = getCurrentlyEditingId(state);

    const previousSibling = getPreviousSiblingViaGraph({
        elements,
        elementGraph,
        elementId: currentlyEditingId,
        sortFn: sortByScoreProperty,
    });

    const taskListId = getTaskListAncestorId(elements, currentlyEditingId);
    const currentDepth = getDepth(elements, taskListId, currentlyEditingId);
    const remainingDepth = MAX_TASK_DEPTH - currentDepth;

    return !previousSibling || remainingDepth < 1;
};

export const isUnindentTaskToolDisabledSelector = (state: ImmutableMap) => {
    const elements = getElements(state);
    const currentlyEditingId = getCurrentlyEditingId(state);

    const parent = getParent(elements, currentlyEditingId);

    return !parent || isTaskList(parent);
};
